import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ReportService } from '../services/report.service';
import { Revenue } from '../data/revenue';
import { FuncsService } from '../services/funcs.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-report-monthly-revenue',
  templateUrl: './report-monthly-revenue.component.html',
  styleUrls: ['./report-monthly-revenue.component.css'],
  standalone: false
})
export class ReportMonthlyRevenueComponent implements OnInit, AfterViewInit {
  public loading = "Loading...";
  displayedColumns: string[] = ['year', 'month', 'revenue'];

  report: Revenue[] = [];
  searchText: string = '';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource = new MatTableDataSource<Revenue>(this.report);

  constructor(
    private reportService: ReportService,
    private funcs: FuncsService
  ) { }

  ngOnInit(): void {
    this.funcs.checkAdmin();
    this.loading = "Loading...";

    this.getReportData();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getReportData() {
    this.reportService.getMonthlyRevenue().subscribe(report => {
      this.report = report;
      this.dataSource.data = this.report;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.loading = "";
    });
  }

  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchText = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  clearSearch() { 
    this.searchText = '';
    this.applyFilter({ target: { value: '' } });
  }
}
